import React, { useEffect, useState } from 'react';
import { Box, useTheme } from 'native-base';
import { BottomNav, useAppSettings, useI18n, useSpringBigStore } from '@springbig/shared';
import Pressable from './Pressable';
import { Caption } from './Typography';
import routes, { AppRouteProps, useAppNavigate } from '~/pages';
import { useBottomNavigationStyles } from './styles';
import { generatePath } from '~/utils/url';
import { I18nReacher } from '@springbig/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Image from '~/shared/Image';

const BottomNavigation = () => {

    const [links, setLinks] = useState<(BottomNav | RouteProps)[]>([]);
    const { member, walletId, merchant } = useSpringBigStore();
    const { navigate, location } = useAppNavigate();
    const { bottomTabsLength, bottomNav } = useAppSettings();
    const theme = useTheme();
    const { t } = useI18n();

    const {
        inactive_icon_color,
        active_icon_color,
        background,
    } = useBottomNavigationStyles();
    const currentPath = location.pathname;

    const populatePaths = (items: Array<BottomNav>): Array<BottomNav> => {

        items.forEach((item) => {

            item.path = routes.find(route => route.title === item.toScreen && route.mainPage)?.path;
            return item;
        });

        return items;
    };

    const populateIcons = (items: Array<BottomNav>): void => {

        items.forEach((item) => {

            item.icon = routes.find((route) => route.path === item.path).icon;
            return item;
        });
    };

    useEffect(
        () => {

            let _items = populatePaths(bottomNav);

            populateIcons(_items);

            if (merchant && member) {

                if (!member.subscriptions_enabled) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Subscriptions');
                }

                if (!member.gift_card_enabled) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'SpringbigPay');
                }

                if (!member.show_milestones) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Milestones');
                }

                if (!member.show_rewards) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Rewards');
                }

                if (!member.merchant_website) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Cart');
                }

                if (!member.referrals?.active) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Refer');
                }

                if (!merchant.dutchie_plus_enabled) {
                    _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Shop');
                }
            }

            setLinks(_items);
        },
        [member]
    );

    const handleNavigation = (path: string) => {

        const _path = generatePath(path, walletId) as AppRouteProps;
        navigate(_path as AppRouteProps);
    };

    const handleColor = (path: string) => {

        if (currentPath.split('/')[3] === path.split('/')[2]) {
            return (!background && theme.colors.primary === active_icon_color) ? theme.colors.secondary : active_icon_color;
        }

        return inactive_icon_color;
    };

    const tabsLength = bottomTabsLength || 4;

    return (
        <Box
            zIndex={999}
            w={'100%'}
            bg={'transparent'}
            height={'75px'}
            display={'flex'}
            flexDirection={'row'}
        >
            {links.map((el, i) => {

                if (i + 1 > tabsLength) {
                    return <div key={i}></div>;
                }

                const filteredNavItem = bottomNav && el && (bottomNav.filter(nav => {

                    return nav.toScreen === (el as BottomNav).toScreen || nav.toScreen === (el as RouteProps).title;
                }) as BottomNav)[0];
                const in18n = ((el as BottomNav).i18n || `navigation.${(el as RouteProps).title?.toLowerCase()}`) as I18nReacher;

                return (
                    <Pressable
                        justifyContent={'center'}
                        alignItems={'center'}
                        flex={1}
                        bg={background}
                        key={i}
                        onPress={() => handleNavigation(el.path)}
                    >
                        <BottomNavIcon
                            navInfo={{ ...el, customIcons: filteredNavItem?.customIcons }}
                            color={handleColor(el.path)}
                            isActive={currentPath.split('/')[3] === el.path.split('/')[2]}
                        />
                        <Caption mt={1} fontSize={12} color={handleColor(el.path)}>
                            {filteredNavItem?.customLabel !== '  ' && filteredNavItem?.customLabel || t(in18n)}
                        </Caption>
                    </Pressable>
                );
            })}
        </Box>
    );
};

const BottomNavIcon = ({
    navInfo,
    color,
    isActive
}: {
    navInfo: RouteProps | BottomNav,
    color: string,
    isActive: boolean
}) => {


    const icon = navInfo && (navInfo as BottomNav)?.customIcons;

    if (icon) {

        return <Image
            uri={isActive ? icon.on : icon.off}
            width={'100%'}
            h={'24px'}
            w={'24px'}
        />;
    }
    else if (navInfo.icon) {
        return <Box
            h={'24px'}
            w={'24px'}
        >
            <FontAwesomeIcon
                icon={typeof navInfo.icon === 'string' ? fas[navInfo.icon] : navInfo.icon}
                color={color}
                style={{ width: '24px', height: '24px !important', margin: 'auto' }}
            />
        </Box>;
    }

    return <Box></Box>;

};

export default BottomNavigation;
